import { useRef, useState } from "react";
import { useTurnstileAction } from '../../Utils/turnstile';
import { getBearerToken, downloadResume } from '../../api';
import './Footer.css';
import { useAnimationsEnabled } from '../../AnimationContext';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const downloadingRef = useRef(false);
    const [downloading, setDownloading] = useState(false);
    const [error, setError] = useState(null);
    const [delayed, setDelayed] = useState(false);
    const { getTurnstileToken } = useTurnstileAction();
    const animationsEnabled = useAnimationsEnabled();

    const handleResumeDownload = async () => {
        if (downloadingRef.current) return;
        setError(null);
        setDelayed(false);
        downloadingRef.current = true;
        setDownloading(true);
        let delayTimeout;
        try {
            delayTimeout = setTimeout(() => setDelayed(true), 3000);
            const turnstileToken = await getTurnstileToken('resume_download');
            const bearerToken = await getBearerToken();
            const deviceId = localStorage.getItem('device_id') || '';
            const blob = await downloadResume(turnstileToken, bearerToken, deviceId);
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank', 'noopener,noreferrer');
            setTimeout(() => window.URL.revokeObjectURL(url), 10000);
        } catch (e) {
            setError(e.message || 'Failed to open resume');
        } finally {
            clearTimeout(delayTimeout);
            downloadingRef.current = false;
            setDownloading(false);
        }
    };

    return (
        <>
            <footer id="footer" className={animationsEnabled ? "animations-enabled" : ""}>
                <div id="footer-content">
                    <div id="footer-section">
                        <p>&copy; {currentYear} Sahand Nikoo. All rights reserved.</p>
                    </div>
                    {(downloading || error) && (
                        <span
                            id="resume-loading"
                            className={error ? "error" : ""}
                            aria-live="polite"
                        >
                            {error
                                ? error
                                : delayed
                                    ? "Server may take up to 50 seconds to respond..."
                                    : "Fetching from servers..."}
                        </span>
                    )}
                    <div id="footer-section">
                        <button onClick={e => { e.preventDefault(); handleResumeDownload(); }}>
                            Resume
                        </button>
                        <a href="mailto:info@sahandnikoo.com">Email</a>
                        <a href="https://linkedin.com/in/sahandnikoo" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                        <a href="https://github.com/TheBudgieDev" target="_blank" rel="noopener noreferrer">GitHub</a>
                    </div>
                </div>
            </footer>
        </>
    );
};
export default Footer;